import { useLocation } from 'react-router-dom';
import { useWindowManager, useWindowed } from '@/lib/context/WindowManagerContext';

// ── Mobile window taskbar ───────────────────────────────────────────────────
// Phones get the same windowing as desktop (windows open full-screen there);
// this slim bottom bar is where minimized windows live — tap a chip to bring
// the window back, tap the active one to minimize it, x to close. Hidden on
// md+ (the desktop taskbar's WindowButtons cover it) and in the portal.

export const MobileWindowBar = () => {
  const { windows, activeId, minimizeWindow, restoreWindow, focusWindow, closeWindow } = useWindowManager();
  const windowed = useWindowed();
  const { pathname } = useLocation();

  if (windowed || windows.length === 0 || pathname.startsWith('/portal')) return null;

  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#1e1e2e]/95 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center gap-1.5 px-2 py-1.5 overflow-x-auto scrollbar-none">
        {windows.map(win => {
          const isFront = activeId === win.id && !win.minimized;
          return (
            <div
              key={win.id}
              className={`flex items-center rounded-xl flex-shrink-0 max-w-[70vw] border ${
                isFront
                  ? 'bg-[#C77D3F]/25 border-[#C77D3F]/40'
                  : win.minimized
                    ? 'bg-white/5 border-white/10'
                    : 'bg-white/10 border-white/10'
              }`}
            >
              <button
                onClick={() =>
                  win.minimized ? restoreWindow(win.id) : isFront ? minimizeWindow(win.id) : focusWindow(win.id)
                }
                className="flex items-center gap-1.5 min-h-[44px] pl-3 pr-1 min-w-0"
                title={win.minimized ? `Restore ${win.title}` : isFront ? `Minimize ${win.title}` : `Show ${win.title}`}
              >
                <span className={`material-symbols-outlined text-lg flex-shrink-0 ${isFront ? 'text-[#C77D3F]' : win.minimized ? 'text-gray-500' : 'text-gray-300'}`}>
                  {win.icon}
                </span>
                <span className={`text-sm font-medium truncate ${isFront ? 'text-[#C77D3F]' : win.minimized ? 'text-gray-500' : 'text-gray-200'}`}>
                  {win.title}
                </span>
              </button>
              <button
                onClick={() => closeWindow(win.id)}
                className="w-9 min-h-[44px] flex items-center justify-center text-gray-500 active:text-red-400 flex-shrink-0"
                title={`Close ${win.title}`}
              >
                <span className="material-symbols-outlined text-base">close</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
